import request from "./request";

const MenuService = {
    GetAll: async (context, signal) => {
        return await request.sendRequest(`/menu/all`, context.token, signal);
    },
    GetMenus: async (userId, context, signal) => {
        return await request.sendRequest(`/menu/format/${userId}`, context.token, signal);
    },
};

export default MenuService;
